module.exports = __webpack_public_path__ + "static/img/huaweiMate20Pro.b0f1e626.png";